import { HttpErrorResponse, HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import e, { response } from 'express';
import { ToastrService } from 'ngx-toastr';
import { CameraServerService } from 'src/app/camera-server/camera-server.service';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AppConstants, ErrorMessageFormField, FARM_TYPE_LIST } from 'src/app/shared/app-constants';


interface FarmType {
  name: string,
  value: string
}

@Component({
  selector: 'app-export-delete-import',
  templateUrl: './export-delete-import.component.html',
  styleUrls: ['./export-delete-import.component.scss']
,
  standalone: false
})
export class ExportDeleteImportComponent implements OnInit {
  headerName: string = '';
  userForm: FormGroup;
  importForm: FormGroup;
  errorMessageFormField: any = {
    potentialId: 'Potential ID is required'
  };
  deleteButton: boolean = false;
  importButton: boolean = false;
  exportButton: boolean = false;  
  fileName: any;
  loggedInUser: string;
  isImportSite: any;
  
  farmTypeData: FarmType[] = FARM_TYPE_LIST;
  uploadedFile: any;
  selectSiteFile: any;
  farmChangedValue: any;
  constructor(
    private fb: FormBuilder,
    private camService: CameraServerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ExportDeleteImportComponent>,
    private toaster: ToastrService,
    public spinner: SpinnerService,
  ) { }

  ngOnInit(): void {
    this.isImportSite = this.data?.isDeleteSite;
    let user = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
    this.loggedInUser = user?.given_name;

    this.fileName = this.data?.response?.unitId
    this.headerName = "Delete Site";
    this.userForm = this.fb.group({
      potentialId: [this.data?.response?.vtigerPotentialId, Validators.required]
    });
  }
  checkPotentialId(value: string): void {
    let inputValue = parseInt(value);
    if(inputValue === this.data?.response?.vtigerPotentialId){
      this.exportButton = false;
    } else {
      this.exportButton = true;
    }
  }

  export() {
     if(this.userForm.value){
      let payload:any = {
        potentialId:this.userForm?.value['potentialId']
      }
      this.spinner.activate();
      this.camService.exportSite(payload?.potentialId).subscribe(
        (response:HttpResponse<any>) => {
          const blob = new Blob([response?.body], { type: 'application/zip' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.style.display = 'none';
          a.href = url;
          a.download = `${this.fileName}.zip`;
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          this.spinner.deactivate();
          this.toaster.success('Site Exported Successfully !!!')
        },
        (error: any) => {
          console.error('Error downloading ZIP file:', error);
          this.toaster.error(AppConstants.defaultErrorMessage);
        }
      );
     }
    this.exportButton = true;
    this.deleteButton = true;
    this.importButton = true;
  }



  delete() {
    let payload:any = {
      potentialId:this.userForm?.value['potentialId']
    }
    this.spinner.activate();
    this.camService.deleteSiteFarm(payload?.potentialId,this.loggedInUser).subscribe((res:any)=>{
      if(res && res?.success == true){
        this.spinner.deactivate();
        this.dialogRef.close(true);
        this.toaster.success('Site Deleted Succesfully!!')
      } else {
        this.spinner.deactivate();
        this.toaster.error(AppConstants.defaultErrorMessage)
      }
    },(error:any)=>{
      if(error){
        this.spinner.deactivate();
        this.toaster.error(AppConstants.defaultErrorMessage)
      }
    })
  }

  farmChange(event:any){
    if (event?.value) {
      this.farmChangedValue = event?.value;
    } else {
      this.farmChangedValue = null;
    }
  }
  onFileSelected(event: any) {
    this.selectSiteFile = event?.target?.files[0] || null;
  }
  isImportButtonEnabled(): boolean {
    return !!this.farmChangedValue && !!this.selectSiteFile;
  }
  import() {
    if (!this.isImportButtonEnabled()) {
      return;
    }  
    this.spinner.activate()
      const formData:FormData = new FormData();
      formData.append('file', this.selectSiteFile);
      // formData.append('farmType', this.farmChangedValue);
      this.camService.importSite(formData).subscribe((res:any)=>{
        if (res?.success === true && res?.data) {
          this.spinner.deactivate();
          this.dialogRef.close(true);          
          this.toaster.success('Site Imported Successfully !!!')
        }
      },(error:HttpErrorResponse)=>{
        if(error.status === 500){
          this.toaster.warning(error?.error || AppConstants.defaultErrorMessage);
          this.spinner.deactivate();
        } else {
          this.toaster.error(AppConstants.defaultErrorMessage);
          this.spinner.deactivate();
        }
      })
    }
  }
